module.exports = __webpack_public_path__ + "img/message.62d92682.svg";